import React, { useState, useEffect } from "react";
import ModalContainer from "../../modalContainer/modalContainer";
import "./styles.css";
import CorporateOnboardingStepper from "../components/CorporateOnboardingStepper/CorporateOnboardingStepper";
import useQuestionaire from "../hooks/useQuestionaire";
import useUser from "../../../customHooks/useUser";
import SimpleButtonWrapper from "../../simpleButtonWrapper/simpleButtonWrapper";
import Button from "../../button/button";
import DeveloperOnboardingStepper from "../components/DeveloperOnboardingStepper/DeveloperOnboardingStepper";

function _renderOnBoardings(userType, activeStep, setActiveStep) {
  switch (userType) {
    case "DEVELOPER":
      return (
        <DeveloperOnboardingStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      );
    case "CORPORATE":
      return (
        <CorporateOnboardingStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
        />
      );
    default:
      return;
  }
}

const OnboardingContainer = ({ canClose = true }) => {
  const {
    isEdit,
    showQuestionaire,
    handleQuestionaire,
    fetchAndSelectUserType,
    createFreelancerDirectly,
  } = useQuestionaire();
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const { userType } = useUser();

  const handleClose = () => {
    handleQuestionaire("CLOSE");
    setSelectedUserType(null); // Reset to show user type selection on reopen
    setActiveStep(0); // Reset form steps
  };

  useEffect(() => {
    // Only auto-select user type when editing existing questionnaire
    if (isEdit && userType === "CORPORATE") {
      setSelectedUserType("CORPORATE");
    } else if (isEdit && userType === "DEVELOPER") {
      setSelectedUserType("DEVELOPER");
    }
    // For new questionnaires, let user select manually
  }, [userType, isEdit]);

  // Reset state when modal closes (from any source including success)
  useEffect(() => {
    if (!showQuestionaire && !isEdit) {
      setSelectedUserType(null);
      setActiveStep(0);
    }
  }, [showQuestionaire, isEdit]);

  return (
    <ModalContainer
      shouldCloseOnOverlayClick={false}
      isOpen={showQuestionaire || isEdit}
      className={"onboarding-modal-container"}
      closeIcon={canClose || userType === "CORPORATE"}
      closeModal={handleClose}
    >
      {_renderOnBoardings(selectedUserType, activeStep, setActiveStep)}

      {!selectedUserType && (
        <OnboardingIntro
          handleSelect={(value) => {
            fetchAndSelectUserType(value);
            setSelectedUserType(value);
            setActiveStep(0); // Reset to first step when selecting user type
          }}
        />
      )}
    </ModalContainer>
  );
};

export default OnboardingContainer;

const OnboardingIntro = ({ handleSelect }) => {
  const { userName, userType } = useUser();
  const developer = userType === "DEVELOPER";
  console.log(userType);
  return (
    <React.Fragment>
      <div className="modal__title">{`Welcome ${userName} !`}</div>
      {userType && (
        <div style={{ marginTop: "12px" }}>
          {`Your Current selection is ${userType}, do you want to change it ?`}
        </div>
      )}
      <div className="onboarding-modal-content">
        <p>Are you a</p>
        <SimpleButtonWrapper>
          <Button onClick={() => handleSelect("CORPORATE")}>
            Business Representative
          </Button>
        </SimpleButtonWrapper>
        <p> or</p>
        <SimpleButtonWrapper>
          <Button
            onClick={() => handleSelect("DEVELOPER")}
            style={developer ? { background: "#1c869d" } : {}}
            disabled={developer}
          >
            Freelance Developer
          </Button>
        </SimpleButtonWrapper>
        <p>?</p>
      </div>
      <div className="onboarding-modal-footer">
        <p>Your NBG Technology Hub Journey just started! Enjoy.</p>
      </div>
    </React.Fragment>
  );
};
